<a
  [routerLink]="routerUrl"
  (click)="wipeOutMakes()"
  [queryParams]="preservedParams"
  [ngClass]="{ 'fs-17 bold': isActive }"
  class="media category-card-url align-items-center"
>
  <div class="image-container">
    <div class="mr-3 image-background"></div>
    <img
      class="category-image"
      [class.image-error]="imageError"
      *ngIf="categoryImageUrl"
      [src]="categoryImageUrl"
      [attr.alt]="category.label"
      (error)="onImageError($event)"
    />
  </div>
  <div class="media-body d-flex">
    <div>{{ category.label }}</div>
  </div>
</a>

<ng-container *ngIf="isActive && makes?.length">
  <!-- Always visible makes -->
  <div *ngFor="let make of makes | slice: 0:visibleLimit">
    <a
      [routerLink]="getMakeRouterUrl(make.value)"
      [queryParams]="preservedParams"
      routerLinkActive="bold"
      class="text-decoration-none make-link d-flex margin-left-for-image"
    >
      <span>{{ make.value }}</span>
      <span class="text-grey ml-auto">({{ make.count }})</span>
    </a>
  </div>

  <!-- Extra makes in details -->
  <details (toggle)="onToggle($event)" *ngIf="makes.length > visibleLimit" class="margin-left-for-image mt-1">
    <summary class="btn btn-link p-0 text-decoration-none">{{ isExpanded ? "Show Less" : "Show All" }}</summary>
    <div class="mt-1">
      <div *ngFor="let make of makes | slice: visibleLimit">
        <a [routerLink]="getMakeRouterUrl(make.value)" [queryParams]="preservedParams" routerLinkActive="bold" class="text-decoration-none make-link d-flex">
          <span>{{ make.value }}</span>
          <span class="text-grey ml-auto">({{ make.count }})</span>
        </a>
      </div>
    </div>
  </details>
</ng-container>
